exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".template-description {\n  margin-top: 10px;\n  padding-left: 5%;\n}\n.template-description--loading {\n  margin-bottom: 10px;\n}\n.template-description .spinner {\n  display: block;\n  margin: 0 auto;\n}\n", ""]);

